import { render, staticRenderFns } from "./integral-goods-form.vue?vue&type=template&id=4b6067fe&"
import script from "./integral-goods-form.vue?vue&type=script&lang=js&"
export * from "./integral-goods-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports